import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { BreadcrumbItem, Breadcrumbs } from '@digital-platform/rs-cms/domain';
import { BreadcrumbsComponent } from '@digital-platform/rs-shared/ui';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';

@Component({
  selector: 'digital-platform-breadcrumbs-ptype',
  standalone: true,
  imports: [CommonModule, BreadcrumbsComponent],
  templateUrl: './breadcrumbs-ptype.component.html',
})
export class BreadcrumbsPtypeComponent
  extends BasePTypeComponent
  implements Breadcrumbs
{
  public override type = 'breadcrumbs' as const;

  @Input() public hideHome = false;
  @Input() public nestedBreadcrumbItem: BreadcrumbItem[] = [];
}
